
import { MenuItem } from 'primevue/menuitem'
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import { useSession } from '@/composables/auth'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'

export default defineComponent({
  emits: ['right-menubutton-click'],
  props: {
    menuActive: Boolean
  },
  setup() {
    let { user, loggedIn, logout } = useSession()
    return {
      user,
      loggedIn,
      logout,
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  data() {
    return {
      bellColor: '#AFBBC4',
      circleFillColor: '#56889F',
      redCircleFillColor: '#F87051',
      licence: {} as any
    }
  },
  computed: {
    userInitials(): string {
      return this.user.first_name.charAt(0) + this.user.last_name.charAt(0)
    },
    menuItems(): MenuItem[] {
      return [
        {
          label: this.$t('menu-section.admin-console'),
          items: [
            {
              label: this.$t('menu-label.user-account'),
              url: process.env.VUE_APP_PLATFORM_ACCOUNT_URL,
              disabled: true
            },
            {
              label: this.$t('menu-label.rgpd'),
              to: '/rgpd',
              icon: 'ci-icon-layers'
            }
          ]
        },
        {
          label: this.$t('menu-section.shop'),
          items: [
            {
              label: this.$t('menu-label.cart'),
              url: process.env.VUE_APP_PLATFORM_SHOP_URL + '/cart'
            },
            {
              label: this.$t('menu-label.orders'),
              url: process.env.VUE_APP_PLATFORM_SHOP_URL + '/orders'
            }
          ]
        }
      ]
    },
    userLicense(): string {
      return this.user.company ? this.$t('user-license.pro') : this.$t('user-license.individual')
    }
  },
  methods: {
    onMenuButtonClick(event: Event) {
      this.$emit('right-menubutton-click', event)
    },
    logOut() {
      this.logout()
    }
  },
  async mounted() {
    if (this.loggedIn) {
      const buildingId = await this.getCurrentBuildingId()
      if (buildingId) {
        const resp = await hemisphereService.getBuilding(buildingId)
        this.licence = resp.data.building?.licence
      }
    }
  }
})
